module.exports = __webpack_public_path__ + "static/media/m-blog-1.b0c45047.jpg";